module.exports = __webpack_public_path__ + "static/media/infoadex_logo.52ffffea.png";